/**
 * Combines conditional class names.
 *
 * This used to wrap `clsx` in `tailwind-merge`, the standard shadcn recipe.
 * It was dropped: tailwind-merge cost **6.4 KB gzipped — 11.6% of the whole
 * bundle** — and this widget ships on customers' pages under a hard size
 * budget. It only earns its weight when a call site passes two conflicting
 * utilities and expects the later one to win, and an audit found exactly
 * three places doing that, all of them additive conditionals that read
 * better as ternaries anyway.
 *
 * The rule this leaves behind: **never pass the same utility twice.** Write
 *
 *     cn(a ? 'mb-0' : 'mb-[6px]')            // one of them
 *
 * not
 *
 *     cn('mb-[6px]', a && 'mb-0')            // both, order decides
 *
 * The second form silently depends on Tailwind's CSS ordering rather than on
 * the class attribute, so it is a bug even with tailwind-merge in place —
 * merge just happened to hide it.
 */

import { clsx, type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
